import StatusCodeError from 'utils/statusCodeError';

export default function HttpError(props) {
    if (typeof window !== 'undefined') {
        window.location.reload();
    }
    throw new StatusCodeError(props.statusCode, props.message);
}
